import { createRouter, createWebHistory } from 'vue-router'
import TheDoor from './pages/TheDoor.vue'
import ListeningChamber from './pages/ListeningChamber.vue'

const routes = [
    {
        path: '/',
        name: 'forge_door',
        component: TheDoor,
        meta: { location: 'flame_companion_forge' }
    },
    {
        path: '/:id',
        name: 'listening_chamber',
        component: ListeningChamber
    }
]

const router = createRouter({
    history: createWebHistory('flame-companion-forge'),
    routes,
})

export default router
